<template>
  <JobDetailRender
    v-if="jobDetailInfo"
    :isPreview="false"
    :jobDetailInfo="jobDetailInfo"
    :jobAndCompanyInfo="jobAndCompanyInfo"
  />
</template>

<script>
import JobDetailRender from '@/components/job/jobDetail/JobDetailRender.vue'
import { mapActions } from 'vuex'
import { NEED_REDIRECT_TO_EXTERNAL_LINK } from '@/constant/job'
import { deviceType } from '@/utils/common'

export default {
  components: { JobDetailRender },
  data () {
    return {
      jobDetailInfo: null,
      jobAndCompanyInfo: null
    }
  },
  computed: {
    isInJoywok () {
      const userAgent = navigator.userAgent
      return userAgent.indexOf('Joywok') !== -1
    },
    shortId () {
      return this.$route.params.jobId
    }
  },
  created () {
    if (this.shortId in NEED_REDIRECT_TO_EXTERNAL_LINK) {
      window.location.href = NEED_REDIRECT_TO_EXTERNAL_LINK[this.shortId]
    } else {
      this.initPageData()
    }
  },
  methods: {
    ...mapActions('account', ['getSessionAccountInfo']),
    ...mapActions('job', ['getJobDetailInfoByShortId']),
    async initPageData () {
      await this.initJobDetailInfo()
      if (deviceType.isPc) {
        const jobId = this.jobDetailInfo.id
        const jobCompany = this.jobAndCompanyInfo.data.company
        this.$router.push({ path: `/recruiting/company/${jobCompany.id}/job/${jobId}/job-detail` })
      }
    },
    async initJobDetailInfo () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const jobInfoParams = {
          shortId: this.shortId,
          params: {}
        }
        const ajSource = this.$route.query.aj_source
        const ajCode = this.$route.query.aj_code
        if (ajSource && ajCode) {
          jobInfoParams.params.aj_source = ajSource
          jobInfoParams.params.aj_code = ajCode
        }
        this.jobAndCompanyInfo = await this.getJobDetailInfoByShortId(jobInfoParams)
        this.jobDetailInfo = this.jobAndCompanyInfo.data?.job || {}
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }

}
</script>

<style>

</style>
